import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CompanyPageStepLicenseComponent } from './company-page-step-license.component';

@NgModule({
  declarations: [CompanyPageStepLicenseComponent],
  imports: [CommonModule, FormsModule],
  exports: [CompanyPageStepLicenseComponent],
  entryComponents: [CompanyPageStepLicenseComponent]
})
export class CompanyPageStepLicenseModule { }
